/* unplugin-vue-components disabled */import { render } from "./supermap.vue?vue&type=template&id=0201447d&scoped=true"
import script from "./supermap.vue?vue&type=script&lang=js"
export * from "./supermap.vue?vue&type=script&lang=js"

import "./supermap.vue?vue&type=style&index=0&id=0201447d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0201447d"]])

export default __exports__